export default __webpack_public_path__ + "static/media/Rabbit.e97da26c.svg";